import {
    markCustomerLower,
    queryCustomerSimpleInfo,
    translateCustomerDev,
    queryCustomerPage,
    addCustomer,
    updateCustomer,
    updateCommonCustomer,
    deleteCustomer,
    queryCustomerAllList,
    queryDevCustomerPage,
    updateDevCustomer,
    queryDevCustomerInfo,
    delayDevCustomer,
    queryKeyManList,
    addKeyMan,
    updateKeyMan,
    deleteKeyMan,
    QueryCustomerCompetitorList,
    developSuccess,
    developFail,
    developStop,
    querySignedList,
    developApproval,
    queryDevelopApprovalRecord,
    translateApplyCustomerDev,
    approvalCustomer,
    queryDevelopApproval,
    queryApproveDetail,
    DeleteCustomerCompetitor,
    AddCustomerCompetitor,
    UpdateCustomerCompetior,
    AddCustomerDepartment,
    QueryDepartmentByCustomerId,
    UpdateCustomerDepartment,
    DeleteCustomerDepartment,
    SaveCustomerDoctor,
    QueryCustomerDoctor,
    DeleteCustomerDoctor,
    UpdateCustomerDoctor,
    UpdateSigned,
    SaveSigned,
    QueryLetterPage,
    QueryDoctorInfo,
    QueryCustomerContacts,
    QueryCustChart,
    QueryCustomerContracts,
    QueryCustomerVisit,
    approvalDelay,
    QueryDevelopInfo,
    UpdateAllFlag,
    DevelopFail,
    QueryChangeLog
} from '@/request/customer';
import { UpdateMark } from '../../request/customer';
export default {
    namespace: true,
    state: {
        customerInfo: {},
        customerInfoAll: {},
        customerList: {},
        customerAllList: [],

        devCustomerList: {},
        keymanList: [],
        competitorList: [],
        signedList: {},
        devCustList: [],
        approvalList: {},
        approveRecord: {},
        submitLoading: false,
        customerDoctor: []
    },

    mutations: {
        SET_CUSTOMER_INFO(state, customerInfo) {
            state.customerInfo = customerInfo;
        },

        SET_CUSTOMER_LIST(state, customerList) {
            state.customerList = customerList;
        },

        SET_CUSTOMER_INFO_ALL(state, customerInfoAll) {
            state.customerInfoAll = customerInfoAll;
        },

        SET_CUSTOMER_ALL_LIST(state, customerAllList) {
            state.customerAllList = customerAllList;
        },

        SET_DEV_CUSTOMER_LIST(state, devCustomerList) {
            state.devCustomerList = devCustomerList;
        },

        SET_DEV_CUSTOMER_LIST_ALL(state, devCustList) {
            state.devCustList = devCustList;
        },

        SET_KEY_MAN_LIST(state, keymanList) {
            state.keymanList = keymanList;
        },

        SET_COMPETITOR_LIST(state, competitorList) {
            state.competitorList = competitorList;
        },
        SET_UPDATE_LOADING(state, submitLoading) {
            state.submitLoading = submitLoading;
        },

        SET_SIGNED_LIST(state, signedList) {
            state.signedList = signedList;
        },

        SET_APPROVAL_LIST(state, approvalList) {
            state.approvalList = approvalList;
        },

        SET_APPROVE_RECORD(state, approveRecord) {
            state.approveRecord = approveRecord;
        },

        SET_CUSTOMER_DOCTOR(state, customerDoctor) {
            state.customerDoctor = customerDoctor;
        }
    },

    actions: {
        QUERY_CUSTOMER_LIST: async ({ commit }, payload) => {
            let res = await queryCustomerPage(payload);
            if (res.code == 200) {
                commit('SET_CUSTOMER_LIST', res.data);
            } else {
                commit('SET_CUSTOMER_LIST', {});
            }

            return res;
        },

        QUERY_CUSTOMER_INFO: async ({ commit }, payload) => {
            let res = await queryCustomerSimpleInfo(payload);
            if (res.code == 200) {
                commit('SET_CUSTOMER_INFO', res.data);
            } else {
                commit('SET_CUSTOMER_INFO', {});
            }
            return res;
        },

        QUERY_CUSTOMER_ALL_LIST: async ({ commit }, payload) => {
            let res = await queryCustomerAllList(payload);
            if (res.code == 200) {
                commit('SET_CUSTOMER_ALL_LIST', res.data.data);
            } else {
                commit('SET_CUSTOMER_ALL_LIST', []);
            }

            return res;
        },

        MARK_CUSTOMER_LOWER: async ({}, payload) => {
            let res = await markCustomerLower(payload);
            return res;
        },

        QUERY_CUSTOMER_VISIT: async ({}, payload) => {
            let res = await QueryCustomerVisit(payload);
            return res;
        },

        TRANSLATE_CUSTOMER_DEV: async ({}, payload) => {
            let res = await translateCustomerDev(payload);
            return res;
        },

        AddCustomer: async ({}, payload) => {
            let res = await addCustomer(payload);
            return res;
        },

        QueryCustomerInfo: async ({}, payload) => {
            let res = await queryCustomerSimpleInfo(payload);
            return res;
        },

        QUERY_CUSTOMER_CONTRACT: async ({ commit }, payload) => {
            let res = await QueryCustomerContracts(payload);
            return res;
        },

        UpdateCustomer: async ({}, payload) => {
            let res = await updateCustomer(payload);
            return res;
        },

        UpdateCommonCustomer: async ({}, payload) => {
            let res = await updateCommonCustomer(payload);
            return res;
        },

        DeleteCustomer: async ({}, payload) => {
            let res = await deleteCustomer(payload);
            return res;
        },

        // TranslateCustomerDev: async ({}, payload) => {
        //     let res = await translateCustomerDev(payload);
        //     return res;
        // },

        saveCustomer: async ({ commit }) => {
            commit('SET_CUSTOMER_INFO_ALL');
        },

        UpdateLoading: async ({ commit }, payload) => {
            commit('SET_UPDATE_LOADING', payload);
        },

        QUERY_DEV_CUSTOMER_PAGE: async ({ commit }, payload) => {
            let res = await queryDevCustomerPage(payload);
            if (res.code == 200) {
                commit('SET_DEV_CUSTOMER_LIST', res.data ?? {});
            }
            return res;
        },

        QUERY_DEV_CUSTOMER_LIST: async ({ commit }, payload) => {
            let res = await queryDevCustomerPage(payload);
            if (res.code == 200) {
                commit('SET_DEV_CUSTOMER_LIST_ALL', res.data.data ?? {});
            }
            return res;
        },
        DEVELOP_FAIL: async ({}, payload) => {
            let res = await DevelopFail(payload);
            return res;
        },

        UPDATE_DEV_CUSTOMER: async ({}, payload) => {
            let res = await updateDevCustomer(payload);
            return res;
        },

        QUERU_DEV_CUSTOMER_INFO: async ({}, payload) => {
            let res = await queryDevCustomerInfo(payload);
            return res;
        },

        QUERY_DEVELOP_INFO: async ({}, payload) => {
            let res = await QueryDevelopInfo(payload);
            return res;
        },
        DELAY_DEV_CUSTOMER: async ({}, payload) => {
            let res = await delayDevCustomer(payload);
            return res;
        },

        DEVELOP_SUCCESS: async ({}, payload) => {
            let res = await developSuccess(payload);
            return res;
        },

        // DEVELOP_FAIL: async ({}, payload) => {
        //     let res = await developFail(payload);
        //     return res;
        // },

        DEVELOP_STOP: async ({}, payload) => {
            let res = await developStop(payload);
            return res;
        },

        APPROVAL_DELAY: async ({}, payload) => {
            let res = await approvalDelay(payload);
            return res;
        },
        QUERY_DEVELOP_APPROVAL_RECORD: async ({ commit }, payload) => {
            let res = await queryDevelopApprovalRecord(payload);
            if (res?.code == 200) {
                commit('SET_APPROVE_RECORD', res.data ?? {});
            }
            return res;
        },

        QUERY_DEVELOP_APPROVAL: async ({ commit }, payload) => {
            let res = await queryDevelopApproval(payload);
            if (res?.code == 200) {
                commit('SET_APPROVAL_LIST', res.data ?? {});
            }
            return res;
        },

        QUERY_APPROVE_DETAIL: async ({}, payload) => {
            let res = await queryApproveDetail(payload);
            return res;
        },

        APPLY_TRANSLATE_CUSTOMER: async ({}, payload) => {
            let res = await translateApplyCustomerDev(payload);
            return res;
        },

        APPROVE_CUSTOMER: async ({}, payload) => {
            let res = await approvalCustomer(payload);
            return res;
        },

        // 已签约

        QUERY_SIGNED_LIST: async ({ commit }, payload) => {
            let res = await querySignedList(payload);
            if (res.code == 200) {
                commit('SET_SIGNED_LIST', res.data ?? {});
            }
            return res;
        },

        SAVE_SIGNED: async ({ commit }, payload) => {
            let res = await SaveSigned(payload);
            return res;
        },

        UPDATE_SIGNED: async ({}, payload) => {
            let res = await UpdateSigned(payload);
            return res;
        },

        UPDATE_MARK: async ({ commit }, payload) => {
            let res = await UpdateMark(payload);
            return res;
        },

        //  关键人
        QUERY_KEY_MAN_LIST: async ({ commit }, payload) => {
            let res = await queryKeyManList(payload);
            if (res?.code == 200) {
                commit('SET_KEY_MAN_LIST', res.data ?? []);
            }
            return res;
        },

        ADD_KEY_MAN: async ({}, payload) => {
            let res = await addKeyMan(payload);
            return res;
        },

        UPDATE_KEY_MAN: async ({}, payload) => {
            let res = await updateKeyMan(payload);
            return res;
        },

        DELETE_KEY_MAN: async ({}, payload) => {
            let res = await deleteKeyMan(payload);
            return res;
        },

        // 竞争对手
        QUERY_CUSTOMER_COMPETIOR_LIST: async ({ commit }, payload) => {
            let res = await QueryCustomerCompetitorList(payload);
            if (res?.code == 200) {
                commit('SET_COMPETITOR_LIST', res.data);
            }
            return res;
        },

        DELETE_CUSTOMER_COMPETIOR: async ({ commit }, payload) => {
            let res = await DeleteCustomerCompetitor(payload);
            return res;
        },

        ADD_CUSTOMER_COMPETIOR: async ({ commit }, payload) => {
            let res = await AddCustomerCompetitor(payload);
            return res;
        },

        UPDATE_CUSTOMER_COMPETIOR: async ({}, payload) => {
            let res = await UpdateCustomerCompetior(payload);
            return res;
        },

        ADD_CUSTOMER_DEPARTMENT: async ({}, payload) => {
            let res = await AddCustomerDepartment(payload);
            return res;
        },

        UPDATE_CUSTOMER_DEPARTMENT: async ({}, payload) => {
            let res = await UpdateCustomerDepartment(payload);
            return res;
        },

        DELETE_CUSTOMER_DEPARTMENT: async ({}, payload) => {
            let res = await DeleteCustomerDepartment(payload);
            return res;
        },

        QUERY_DEPARTMENT_CUSTOMERID: async ({}, payload) => {
            let res = await QueryDepartmentByCustomerId(payload);
            return res;
        },

        // 联系人

        QUERY_CUSTOMER_DOCTOR: async ({ commit }, payload) => {
            let res = await QueryCustomerDoctor(payload);
            if (res?.code == 200) {
                commit('SET_CUSTOMER_DOCTOR', res.data ?? []);
                // commit('SET_KEY_MAN_LIST', res.data ?? []);
            }
            return res;
        },

        SAVE_CUSTOMER_DOCTOR: async ({}, payload) => {
            let res = await SaveCustomerDoctor(payload);
            return res;
        },

        DELETE_CUSTOMER_DOCTOR: async ({}, payload) => {
            let res = await DeleteCustomerDoctor(payload);
            return res;
        },

        UPDATE_CUSTOMER_DOCTOR: async ({}, payload) => {
            let res = await UpdateCustomerDoctor(payload);
            return res;
        },

        QUERY_DOCTOR_INFO: async ({ commit }, payload) => {
            let res = await QueryDoctorInfo(payload);
            return res;
        },

        QUERY_LETTER_PAGE: async ({ commit }, payload) => {
            let res = await QueryLetterPage(payload);
            return res;
        },

        QUERY_CUSTOMER_CONTACTS: async ({ commit }, payload) => {
            let res = await QueryCustomerContacts(payload);
            return res;
        },

        QUERY_CUST_CHART: async ({ commit }, payload) => {
            let res = await QueryCustChart(payload);
            return res;
        },
        UPDATE_ALL_FLAG: async ({}, payload) => {
            let res = await UpdateAllFlag(payload);
            return res;
        },
        // 修改记录
        QUERY_CHANGE_LOG: async ({}, payload) => {
            let res = await QueryChangeLog(payload);
            return res;
        }
    }
};
